import React from 'react'
import { Helmet } from "react-helmet"

export default React.memo(
	({
		author,
		canonicalUrl,
		datePublished,
		defaultTitle,
		description,
		image,
		isBlogPost,
		title,
		url,
	}) => {
		const baseSchema = [
			{
				'@context': 'http://schema.org',
				'@type': 'WebSite',
				url,
				name: defaultTitle,
				alternateName: defaultTitle,
			},
		];

		const schema = isBlogPost
			? [
				...baseSchema,
				{
					'@context': 'http://schema.org',
					'@type': 'BreadcrumbList',
					itemListElement: [
						{
							'@type': 'ListItem',
							position: 1,
							item: {
								'@id': url,
								name: title,
								image,
							},
						},
					],
				},
				{
					'@context': 'http://schema.org',
					'@type': 'BlogPosting',
					url,
					name: title,
					alternateName: defaultTitle,
					headline: title,
					image: {
						'@type': 'ImageObject',
						url: image,
					},
					description,
					author: {
						'@type': 'Person',
						name: author,
					},
					publisher: {
						'@type': 'Organization',
						url: url,
						logo: {
							'@type': 'ImageObject',
							url: 'https://www.anonimoconiglio.com/static/rabbit_logo.png',
							height: '500',
							width: '511'
						},
						name: defaultTitle
					},
					mainEntityOfPage: {
						'@type': 'WebSite',
						'@id': canonicalUrl,
					},
					datePublished,
					dateModified: datePublished
				},
			]
			: baseSchema;

		return (
			<Helmet>
				{/* Schema.org tags */}
				<script type="application/ld+json">{JSON.stringify(schema)}</script>
			</Helmet>
		);
	},
);